import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "C:\\Users\\nahus\\Desktop\\Xfactor\\xfactor-frontend\\node_modules\\sonner\\dist\\index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\nahus\\Desktop\\Xfactor\\xfactor-frontend\\src\\components\\AxiosProvider.tsx");
;
import(/* webpackMode: "eager" */ "C:\\Users\\nahus\\Desktop\\Xfactor\\xfactor-frontend\\src\\styles\\tailwind.css");
